import { ConsentStrategyInterface } from "./consent-strategy-interface";
import { Consents } from "@identity/services";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import { UspApi } from "../consentProviders/usp-api";

@singleton()
export class FandomUSConsentStrategy implements ConsentStrategyInterface {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(UspApi) private readonly uspApi: UspApi,
  ) {}

  get(): Promise<Consents> {
    this.logger.info("__uspapi installed");
    return this.uspApi.consentGiven;
  }
}
